var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("header", { staticClass: "header" }, [
    _vm.login
      ? _c(
          "nav",
          { staticClass: "navbar navbar-dark bg-dark navbar-expand-md" },
          [
            _vm.pageAdmin && _vm.loginUser.isAdmin
              ? _c("router-link", {
                  staticClass: "navbar-brand",
                  attrs: { to: "/admin/top" }
                })
              : _c("router-link", {
                  staticClass: "navbar-brand",
                  attrs: { to: "/operator/top" }
                }),
            _vm._v(" "),
            _vm._m(0),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "collapse navbar-collapse",
                attrs: { id: "navbarSupportedContent" }
              },
              [
                _vm.pageAtmanage
                  ? _c(
                      "ul",
                      { staticClass: "navbar-nav mr-auto mt-2 mt-md-0" },
                      [
                        _vm.hasAnyRole(
                          "ROLE_ADMIN",
                          "ROLE_YUKYU_READ",
                          "ROLE_YUKYU_ADMIN"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  attrs: { href: "/atmanage/company/top" }
                                },
                                [_vm._v("契約企業管理")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              on: { click: _vm.goToAdminTop }
                            },
                            [_vm._v("戻る")]
                          )
                        ])
                      ]
                    )
                  : _vm.pageAdmin
                  ? _c(
                      "ul",
                      { staticClass: "navbar-nav mr-auto mt-2 mt-md-0" },
                      [
                        _vm.hasAnyRole(
                          "ROLE_ADMIN",
                          "ROLE_YUKYU_READ",
                          "ROLE_YUKYU_ADMIN"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  on: { click: _vm.goToLeaveRequestManage }
                                },
                                [_vm._v("休暇申請管理")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasAnyRole(
                          "ROLE_ADMIN",
                          "ROLE_KOTSUHI_READ",
                          "ROLE_KOTSUHI_ADMIN"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  on: { click: _vm.goToKotsuhiManage }
                                },
                                [_vm._v("交通費管理")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasAnyRole(
                          "ROLE_ADMIN",
                          "ROLE_WORK_READ",
                          "ROLE_WORK_ADMIN"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  on: { click: _vm.goToWorkManage }
                                },
                                [_vm._v("勤怠管理")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.hasAnyRole(
                          "ROLE_ADMIN",
                          "ROLE_USER_READ",
                          "ROLE_USER_ADMIN"
                        )
                          ? _c("li", { staticClass: "nav-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  on: { click: _vm.goToUserManage }
                                },
                                [_vm._v("ユーザ管理")]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _vm.hasAnyRole("ROLE_ADMIN", "ROLE_MANAGE")
                            ? _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  on: { click: _vm.goToConfManage }
                                },
                                [_vm._v("設定")]
                              )
                            : _vm._e()
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              on: { click: _vm.goToOperatorTop }
                            },
                            [_vm._v("個人カレンダーをみる")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _vm.hasAnyRole("ROLE_ATMANAGE")
                            ? _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  on: { click: _vm.goToAtmanageTop }
                                },
                                [_vm._v("システム管理")]
                              )
                            : _vm._e()
                        ])
                      ]
                    )
                  : _c(
                      "ul",
                      { staticClass: "navbar-nav mr-auto mt-2 mt-md-0" },
                      [
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              on: { click: _vm.goToOperatorTop }
                            },
                            [_vm._v("カレンダー")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              on: { click: _vm.goToOperatorWork }
                            },
                            [_vm._v("勤務表")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              on: { click: _vm.goToOperatorLeaveRequest }
                            },
                            [_vm._v("休暇申請履歴")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              on: { click: _vm.goToOperatorKotsuhiUnpaid }
                            },
                            [
                              _vm._v("交通費履歴\n                      "),
                              _vm.unpaidCount > 0
                                ? _c(
                                    "span",
                                    {
                                      staticClass: "badge badge-info badge-pill"
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          attrs: {
                                            "data-toggle": "tooltip",
                                            "data-placement": "top",
                                            "data-html": "true",
                                            title:
                                              _vm.unpaidCount +
                                              "件、未精算の交通費があります"
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                              " +
                                              _vm._s(_vm.unpaidCount) +
                                              "\n                          "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _c(
                            "a",
                            {
                              staticClass: "nav-link",
                              on: { click: _vm.goToOperatorSetting }
                            },
                            [_vm._v("個人設定")]
                          )
                        ]),
                        _vm._v(" "),
                        _c("li", { staticClass: "nav-item" }, [
                          _vm.loginUser.isAdmin
                            ? _c(
                                "a",
                                {
                                  staticClass: "nav-link",
                                  on: { click: _vm.goToAdminTop }
                                },
                                [_vm._v("管理画面に戻る")]
                              )
                            : _vm._e()
                        ])
                      ]
                    ),
                _vm._v(" "),
                _c("div", { staticClass: "form-inline my-2 my-lg-0" }, [
                  _c("img", {
                    staticClass: "card-img-top icon",
                    attrs: {
                      src: _vm.loginUser.imageUrl ? _vm.loginUser.imageUrl : "",
                      onerror:
                        "this.src='/src/assets/img/not_found_user_icon.jpg';"
                    }
                  }),
                  _vm._v(" "),
                  _c("p", { staticClass: "text-light m-1 my-2 my-sm-0" }, [
                    _vm._v(_vm._s(_vm.loginUser.userName))
                  ]),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-light my-2 my-sm-0",
                      on: { click: _vm.logout }
                    },
                    [_vm._v("ログアウト")]
                  )
                ])
              ]
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "button",
      {
        staticClass: "navbar-toggler",
        attrs: {
          type: "button",
          "data-toggle": "collapse",
          "data-target": "#navbarSupportedContent",
          "aria-controls": "navbarSupportedContent",
          "aria-expanded": "false",
          "aria-label": "Toggle navigation"
        }
      },
      [_c("span", { staticClass: "navbar-toggler-icon" })]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37ae9fe3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37ae9fe3","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/AsnHeader.vue
// module id = 328
// module chunks = 0